import { render, staticRenderFns } from "./RevisarPedidoDeCompraModal.vue?vue&type=template&id=571e092b&scoped=true"
import script from "./RevisarPedidoDeCompraModal.vue?vue&type=script&setup=true&lang=js"
export * from "./RevisarPedidoDeCompraModal.vue?vue&type=script&setup=true&lang=js"
import style0 from "./RevisarPedidoDeCompraModal.vue?vue&type=style&index=0&id=571e092b&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "571e092b",
  null
  
)

export default component.exports